module.exports = __webpack_public_path__ + "assets/img/memory_leak_process.422b7fa1.jpg";